(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-racing-band"] && !Shopify.designMode) return;
  try {
    
const setupRaceBands = () => {
  document.querySelectorAll('[data-pb-race]:not([data-ready])').forEach(band => {
    band.dataset.ready = 'true';
    const observer = new IntersectionObserver(entries => entries.forEach(entry => band.classList.toggle('is-visible', entry.isIntersecting)));
    observer.observe(band);
  });
};
setupRaceBands();
document.addEventListener('shopify:section:load', setupRaceBands);

  } catch(e) { console.error(e); }
})();
})();
